import {convertToInt} from '@utils/helpers';
import {columnObjectAlignCenter, columnObjectAlignLeft, columnObjectAlignRight} from '@utils/tableHelpers';

export const Columns = {
    'id': {
        label: 'ID',
        sorting: (row) => convertToInt(row.id),
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'name': {label: 'Name', sorting: true},
    'short_name': {label: 'Short name', sorting: true},
    'cdn': {
        label: 'Default CDN',
        sorting: true,
    },
    'live_ingest_method': {
        label: 'Default Live ingest method',
        sorting: true,
        ...columnObjectAlignLeft,
    },
    'recording_ingest_method': {
        label: 'Default Recording ingest method',
        sorting: true,
        ...columnObjectAlignLeft,
    },
    'akamai_cdn_ingest_method': {
        label: 'Akamai CDN ingest method',
        sorting: true,
    },
    'clip_lifetime': {
        label: 'Clip lifetime',
        sorting: (row) => (row.clip_lifetime),
        ...columnObjectAlignRight,
    },
    'is_betting': {
        label: 'Betting',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_akamai_rtmp_distr_region_support': {
        label: 'Akamai RTMP distr. regions',
        sorting: (row) => (row.has_akamai_rtmp_distr_region_support),
        ...columnObjectAlignCenter,
    },
    'has_scoreboard_overlay_support': {
        label: 'Scoreboard overlays',
        sorting: (row) => (row.has_scoreboard_overlay_support),
        ...columnObjectAlignCenter,
    },
    'has_slate_support': {
        label: 'Slates',
        sorting: (row) => (row.has_slate_support),
        ...columnObjectAlignCenter,
    },
    'has_overlay_support': {
        label: 'Overlays',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_ad_support': {
        label: 'Ads',
        sorting: (row) => (row.has_ad_support),
        ...columnObjectAlignCenter,
    },
    'has_drm_support': {
        label: 'DRM',
        sorting: (row) => (row.has_drm_support),
        ...columnObjectAlignCenter,
    },
    'has_cc_support': {
        label: 'CC',
        sorting: (row) => (row.has_cc_support),
        ...columnObjectAlignCenter,
    },
    'has_watermarking_support': {
        label: 'WM',
        sorting: (row) => (row.has_watermarking_support),
        ...columnObjectAlignCenter,
    },
    'has_hq_support': {
        label: 'HQ',
        sorting: (row) => (row.has_hq_support),
        ...columnObjectAlignCenter,
    },
    'has_ll_support': {
        label: 'LL',
        sorting: (row) => (row.has_ll_support),
        ...columnObjectAlignCenter,
    },
    'has_usage_type_support': {
        label: 'Usage types',
        sorting: (row) => (row.has_usage_type_support),
        ...columnObjectAlignCenter,
    },
    'has_geolocation_support': {
        label: 'Geolocation',
        sorting: (row) => (row.has_geolocation_support),
        ...columnObjectAlignCenter,
    },
    'has_event_booking_support': {
        label: 'Event booking',
        sorting: (row) => (row.has_event_booking_support),
        ...columnObjectAlignCenter,
    },
    'has_event_group_notification_support': {
        label: 'Event group notification',
        sorting: (row) => (row.has_event_group_notification_support),
        ...columnObjectAlignCenter,
    },
    'has_report': {
        label: 'Report',
        sorting: (row) => (row.has_report),
        ...columnObjectAlignCenter,
    },
    'is_invoiceable': {
        label: 'Invoiceable',
        sorting: (row) => (row.is_invoiceable),
        ...columnObjectAlignCenter,
    },
    'sla_minimum_threshold': {
        label: 'SLA',
        sorting: (row) => (row.sla_minimum_threshold),
        ...columnObjectAlignCenter,
    },
    'actions': {
        label: 'Actions',
        ...columnObjectAlignCenter,
    },
};
